export type LayoutMainProps = {
  children: any
}

export function LayoutMain({ children }: LayoutMainProps) {
  return <div className="av-base-blucorporate">{children}</div>
}
